export default {
  title: '景德镇御窑厂 后台管理程序',
  version: '0.15.2',
  copyright: '&copy; 2019 景德镇御窑厂',
  link: 'http://docs.zdbx.net',
  subtitle: '景德镇御窑厂'
}


// WEBPACK FOOTER //
// ./src/store/config/footer.js